module.exports = __webpack_public_path__ + "static/AkzidGroProBolExt.524e1ec9.woff2";